const CARD = 'card';
const CASH = 'cash';
const PAY_LATER = 'pay-later';

export { CARD, CASH, PAY_LATER };
